<section class="section-div">
  <div class="header-div">
    <h4><ion-icon name="business-outline"></ion-icon> Document Details</h4>
  </div>
  <div class="content-details">
    <div class="content-div mb-2">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12" [formGroup]="settingsForm">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-rows mt-3" *ngIf="!showForm">
                <mat-label>
                  Endorsement from the head of the host institution
                  <span class="text-danger">*</span>
                  <p class="mb-0">
                    <a class="text-primary newdocments"
                      href="https://startuptn-public-files.s3.ap-south-1.amazonaws.com/StartupTN-PIC-EndorsementForm.pdf"
                      target="_blank">(Form Template)
                      <i class="fas fa-file-pdf ml-2" style="color: #eb0000"></i>
                    </a>
                  </p>
                </mat-label>
                <label *ngIf="disName3 != '✔ Uploaded'" for="input-file-ids3" class="md-button md-raised md-primary">
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName3 }}</span>
                  <input class="d-none" id="input-file-ids3" type="file" formControlName="endorsementfile"
                    (change)="actiondocfileUpload($event)" />
                </label>
                <label *ngIf="disName3 == '✔ Uploaded'" for="input-file-ids3" class="md-button md-raised md-accent">
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName3 }}</span>
                  <input class="d-none" id="input-file-ids3" type="file" (change)="actiondocfileUpload($event)" />
                </label>
                <span class="noti-span">(Supported Format: pdf) (max file size: 10mb)</span>
                <p *ngIf="
                    actionlogoCheck &&
                    selecetdActionFile &&
                    selecetdActionFile.size / (1024 * 1024) > maxSizeMB
                  " class="text-danger">
                  File size exceeds the limit ({{ maxSizeMB }}MB)
                </p>
                <mat-error *ngIf="fileError3 == true">
                  <span>Document is required</span>
                </mat-error>
                <div class="mt-2 mb-3" *ngIf="disNames3 == '✔ Uploaded'">
                  <a class="pdf-btn" href="{{ ActiondisNames }}" target="_blank">Download & View Document</a>
                </div>
              </div>
              <div class="form-rows mt-3" *ngIf="showForm">
                <mat-label>
                  Endorsement from the head of the host institution
                  <span class="text-danger">*</span>
                  <p class="mb-0">
                    <a class="text-primary newdocments"
                      href="https://startuptn-public-files.s3.ap-south-1.amazonaws.com/StartupTN-PIC-EndorsementForm.pdf"
                      target="_blank">(Form Template)
                      <i class="fas fa-file-pdf ml-2" style="color: #eb0000"></i>
                    </a>
                  </p>
                </mat-label>
                <label *ngIf="disName3 != '✔ Uploaded'" for="input-file-ids3" class="md-button md-raised md-primary">
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName3 }}</span>
                  <input class="d-none" id="input-file-ids3" readonly formControlName="endorsementfile" />
                </label>
                <label *ngIf="disName3 == '✔ Uploaded'" for="input-file-ids3" class="md-button md-raised md-accent">
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName3 }}</span>
                  <input class="d-none" id="input-file-ids3" readonly />
                </label>
                <span class="noti-span">(Supported Format: pdf) (max file size: 10mb)</span>
                <p *ngIf="
                    actionlogoCheck &&
                    selecetdActionFile &&
                    selecetdActionFile.size / (1024 * 1024) > maxSizeMB
                  " class="text-danger">
                  File size exceeds the limit ({{ maxSizeMB }}MB)
                </p>
                <mat-error *ngIf="fileError3 == true">
                  <span>Document is required</span>
                </mat-error>
                <div class="mt-2 mb-3" *ngIf="disNames3 == '✔ Uploaded'">
                  <a class="pdf-btn" href="{{ ActiondisNames }}" target="_blank">Download & View Document</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-rows mt-3" *ngIf="!showForm">
                <mat-label>Intent letter from the partnering industry
                  <span class="text-danger">*</span>
                  <p class="mb-0">
                    <a class="text-primary newdocments"
                      href="https://startuptn-public-files.s3.ap-south-1.amazonaws.com/PreInc_Intent_Letter_Template.pdf"
                      target="_blank">(Form Template)
                      <i class="fas fa-file-pdf ml-2" style="color: #eb0000"></i>
                    </a>
                  </p>
                </mat-label>
                <label *ngIf="disName2 != '✔ Uploaded'" for="input-file-ids" class="md-button md-raised md-primary">
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName2 }}</span>
                  <input class="d-none" id="input-file-ids" type="file" formControlName="intentletterfile"
                    (change)="twelldocfileUpload($event)" />
                </label>
                <label *ngIf="disName2 == '✔ Uploaded'" for="input-file-ids" class="md-button md-raised md-accent">
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName2 }}</span>
                  <input class="d-none" id="input-file-ids" type="file" (change)="twelldocfileUpload($event)" />
                </label>
                <span class="noti-span">(Supported Format: pdf) (max file size: 10mb)</span>
                <p *ngIf="
                    twllogoCheck &&
                    selecetdTwelFile &&
                    selecetdTwelFile.size / (1024 * 1024) > maxSizeMB
                  " class="text-danger">
                  File size exceeds the limit ({{ maxSizeMB }}MB)
                </p>
                <mat-error *ngIf="fileError2 == true">
                  <span>Document is required</span>
                </mat-error>
                <div class="mt-2 mb-3" *ngIf="disNames2 == '✔ Uploaded'">
                  <a class="pdf-btn" href="{{ TweldisNames }}" target="_blank">Download & View Document</a>
                </div>
              </div>
              <div class="form-rows mt-3" *ngIf="showForm">
                <mat-label>Intent letter from the partnering industry
                  <span class="text-danger">*</span>
                  <p class="mb-0">
                    <a class="text-primary newdocments"
                      href="https://startuptn-public-files.s3.ap-south-1.amazonaws.com/PreInc_Intent_Letter_Template.pdf"
                      target="_blank">(Form Template)
                      <i class="fas fa-file-pdf ml-2" style="color: #eb0000"></i>
                    </a>
                  </p>
                </mat-label>
                <label *ngIf="disName2 != '✔ Uploaded'" for="input-file-ids" class="md-button md-raised md-primary">
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName2 }}</span>
                  <input class="d-none" id="input-file-ids" readonly formControlName="intentletterfile" />
                </label>
                <label *ngIf="disName2 == '✔ Uploaded'" for="input-file-ids" class="md-button md-raised md-accent">
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName2 }}</span>
                  <input class="d-none" id="input-file-ids" readonly />
                </label>
                <span class="noti-span">(Supported Format: pdf) (max file size: 10mb)</span>
                <p *ngIf="
                    twllogoCheck &&
                    selecetdTwelFile &&
                    selecetdTwelFile.size / (1024 * 1024) > maxSizeMB
                  " class="text-danger">
                  File size exceeds the limit ({{ maxSizeMB }}MB)
                </p>
                <mat-error *ngIf="fileError2 == true">
                  <span>Document is required</span>
                </mat-error>
                <div class="mt-2 mb-3" *ngIf="disNames2 == '✔ Uploaded'">
                  <a class="pdf-btn" href="{{ TweldisNames }}" target="_blank">Download & View Document</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-rows mt-3" *ngIf="!showForm">
                <mat-label>Institution’s annual activity report on Innovation and
                  Entrepreneurship. <span class="text-danger"></span></mat-label>
                <label *ngIf="disName5 != '✔ Uploaded'" for="input-file-ids5" class="md-button md-raised md-primary">
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName5 }}</span>
                  <input class="d-none" id="input-file-ids5" type="file" formControlName="annualActivityFile"
                    (change)="otherrecdocfileUpload($event)" />
                </label>
                <label *ngIf="disName5 == '✔ Uploaded'" for="input-file-ids5" class="md-button md-raised md-accent">
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName5 }}</span>
                  <input class="d-none" id="input-file-ids5" type="file" (change)="otherrecdocfileUpload($event)" />
                </label>
                <span class="noti-span">(Supported Format: pdf) (max file size: 10mb)</span>
                <p *ngIf="
                    otherlogoCheck &&
                    selecetdOtherrecFile &&
                    selecetdOtherrecFile.size / (1024 * 1024) > maxSizeMB
                  " class="text-danger">
                  File size exceeds the limit ({{ maxSizeMB }}MB)
                </p>

                <mat-error *ngIf="fileError5 == true">
                  <span>Document is required</span>
                </mat-error>

                <div class="mt-2 mb-3" *ngIf="disNames5 == '✔ Uploaded'">
                  <a class="pdf-btn" href="{{ OtherrecdisNames }}" target="_blank">Download & View Document</a>
                </div>
              </div>
              <div class="form-rows mt-3" *ngIf="showForm">
                <mat-label>Institution’s annual activity report on Innovation and
                  Entrepreneurship. <span class="text-danger"></span></mat-label>
                <label *ngIf="disName5 != '✔ Uploaded'" for="input-file-ids5" class="md-button md-raised md-primary">
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName5 }}</span>
                  <input class="d-none" id="input-file-ids5" readonly formControlName="annualActivityFile" />
                </label>
                <label *ngIf="disName5 == '✔ Uploaded'" for="input-file-ids5" class="md-button md-raised md-accent">
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName5 }}</span>
                  <input class="d-none" id="input-file-ids5" readonly />
                </label>
                <span class="noti-span">(Supported Format: pdf) (max file size: 10mb)</span>
                <p *ngIf="
                    otherlogoCheck &&
                    selecetdOtherrecFile &&
                    selecetdOtherrecFile.size / (1024 * 1024) > maxSizeMB
                  " class="text-danger">
                  File size exceeds the limit ({{ maxSizeMB }}MB)
                </p>
                <mat-error *ngIf="fileError5 == true">
                  <span>Document is required</span>
                </mat-error>
                <div class="mt-2 mb-3" *ngIf="disNames5 == '✔ Uploaded'">
                  <a class="pdf-btn" href="{{ OtherrecdisNames }}" target="_blank">Download & View Document</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-rows mt-3" *ngIf="!showForm">
                <mat-label>Pitch Deck
                  <span class="text-danger">*</span>
                  <a class="text-primary newdocments ml-2"
                    href="https://startuptn-public-files.s3.ap-south-1.amazonaws.com/Sample-Pitchdeck-PreIncubationCentre.pdf"
                    target="_blank">(Pitch Deck Sample Template)
                    <i class="fas fa-file-pdf ml-2" style="color: #eb0000"></i>
                  </a>
                </mat-label>
                <label *ngIf="disName4 != '✔ Uploaded'" for="input-file-id4" class="md-button md-raised md-primary">
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName4 }}</span>
                  <input class="d-none" id="input-file-id4" type="file" formControlName="pitchdeckfile"
                    (change)="trackrecdocfileUpload($event)" />
                </label>
                <label *ngIf="disName4 == '✔ Uploaded'" for="input-file-id4" class="md-button md-raised md-accent">
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName4 }}</span>
                  <input class="d-none" id="input-file-id4" type="file" (change)="trackrecdocfileUpload($event)" />
                </label>
                <span class="noti-span">(Supported Format: pdf) (max file size: 10mb)</span>
                <p *ngIf="
                    TracklogoCheck &&
                    selecetdTrackrecFile &&
                    selecetdTrackrecFile.size / (1024 * 1024) > maxSizeMB
                  " class="text-danger">
                  File size exceeds the limit ({{ maxSizeMB }}MB)
                </p>
                <mat-error *ngIf="fileError4 == true">
                  <span>Document is required</span>
                </mat-error>
                <div class="mt-2 mb-3" *ngIf="disNames4 == '✔ Uploaded'">
                  <a class="pdf-btn" href="{{ TrackrecdisNames }}" target="_blank">Download & View Document</a>
                </div>
              </div>
              <div class="form-rows mt-3" *ngIf="showForm">
                <mat-label>Pitch Deck
                  <span class="text-danger">*</span>
                  <a class="text-primary newdocments ml-2"
                    href="https://startuptn-public-files.s3.ap-south-1.amazonaws.com/Sample-Pitchdeck-PreIncubationCentre.pdf"
                    target="_blank">(Pitch Deck Sample Template)
                    <i class="fas fa-file-pdf ml-2" style="color: #eb0000"></i>
                  </a>
                </mat-label>
                <label *ngIf="disName4 != '✔ Uploaded'" for="input-file-id4" class="md-button md-raised md-primary">
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName4 }}</span>
                  <input class="d-none" id="input-file-id4" readonly formControlName="pitchdeckfile" />
                </label>
                <label *ngIf="disName4 == '✔ Uploaded'" for="input-file-id4" class="md-button md-raised md-accent">
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ disName4 }}</span>
                  <input class="d-none" id="input-file-id4" />
                </label>
                <span class="noti-span">(Supported Format: pdf) (max file size: 10mb)</span>
                <p *ngIf="
                    TracklogoCheck &&
                    selecetdTrackrecFile &&
                    selecetdTrackrecFile.size / (1024 * 1024) > maxSizeMB
                  " class="text-danger">
                  File size exceeds the limit ({{ maxSizeMB }}MB)
                </p>
                <mat-error *ngIf="fileError4 == true">
                  <span>Document is required</span>
                </mat-error>
                <div class="mt-2 mb-3" *ngIf="disNames4 == '✔ Uploaded'">
                  <a class="pdf-btn" href="{{ TrackrecdisNames }}" target="_blank">Download & View Document</a>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mt-4">
            <button *ngIf="!showForm" mat-raised-button color="primary" (click)="saveBtn()" class="mr-3">
              Save
            </button>
            <!-- *ngIf="
                getValue.enableSaveAll == 1 &&
                roleName == 'Preincubator' &&
                isRegistrationClosedPre == false
              " -->
            <button *ngIf="
                getValue.enableSaveAll == 1 &&
                roleName == 'Preincubator'
              " mat-raised-button color="primary" (click)="submitBtn()">
              Submit
            </button>
            <!-- *ngIf="
                getValue.enableSaveAll == 2 &&
                roleName == 'Preincubator' &&
                isRegistrationClosedPre == false
              " -->
            <button *ngIf="
                getValue.enableSaveAll == 2 &&
                roleName == 'Preincubator'
              " mat-raised-button color="primary" (click)="submitBtn()">
              Re-Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>